import gql from 'graphql-tag';

export default gql`
  mutation {
    userAccept {
      id
      email
      institution {
        id
        name
      }
      institutionType
    }
  }
`;
